import React from 'react';
import { Text, Divider } from '@mantine/core';

type Props = {
    label: string | React.ReactNode;
    value: string | React.ReactNode;
    showDivider?: boolean;
    className?: string;
};

function PriceRow({ label, value, showDivider = true, className }: Props) {
    return (
        <>
            <div className={`flex-1 px-4 py-3 ${className || ''}`}>
                <Text
                    component="div"
                    className="uppercase text-xs text-[#7D8FB3] font-bold"
                >
                    {label}
                </Text>
                <Text component="div" className="font-bold text-primary">
                    {value}
                </Text>
            </div>
            {showDivider && (
                <Divider orientation="vertical" color="#e6e9ef" my="xs" />
            )}
        </>
    );
}

export default PriceRow;
